import { Grid, TextField, TextFieldProps } from '@material-ui/core';
import { InputBaseProps } from '@material-ui/core/InputBase/InputBase';
import { makeStyles } from '@material-ui/core/styles';
import React, { useMemo } from 'react';

import { FileUploadButton } from '~/@components/FileUploadButton';
import { DoneIcon } from '~/@components/Icon';
import { LocalizableText } from '~/@components/LocalizableText';
import { ACCEPTED_DOCUMENT_FILE_TYPES } from '~/config/constants';

import { COLORS } from '../@theme/colors';

export type IFileUploadProps = {
    value: File | null;
    onChange: (v: File) => void;
} & Omit<TextFieldProps, 'onChange'>;

export function FileUpload({ value, onChange, disabled, ...textFieldProps }: IFileUploadProps) {
    const inputProps = useMemo<InputBaseProps>(
        () => (value ? { endAdornment: <DoneIcon htmlColor={COLORS.green} /> } : {}),
        [value]
    );

    const { button } = useStyles();

    return (
        <Grid container spacing={3}>
            <Grid item xs={8}>
                <TextField
                    fullWidth
                    value={value?.name || ''}
                    {...textFieldProps}
                    disabled={true}
                    InputProps={inputProps}
                />
            </Grid>
            <Grid item xs={4}>
                <div className={button}>
                    <FileUploadButton
                        variant="outlined"
                        color="primary"
                        onChange={onChange}
                        acceptFileTypes={ACCEPTED_DOCUMENT_FILE_TYPES}
                        disabled={disabled}
                        fullWidth>
                        <LocalizableText code={value ? 'replace' : 'upload'} />
                    </FileUploadButton>
                </div>
            </Grid>
        </Grid>
    );
}

const useStyles = makeStyles(() => ({
    button: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
    },
}));
